/* 
Copyright (c) Karsten Jeske and John Firth
This source code is licensed under the proprietary license found in the
LICENSE file in the root directory of this source tree.
*/

import React from "react"

type ToastType = "success" | "error" | "info" | "warning"

interface ToastNotificationProps {
  show: boolean
  title: string
  message: React.ReactNode
  type?: ToastType
  onClose: () => void
}

const ToastNotification: React.FC<ToastNotificationProps> = ({
  show,
  title,
  message,
  type = "info",
  onClose,
}) => {
  const colorMap: Record<ToastType, string> = {
    success: "bg-success",
    error: "bg-danger",
    info: "bg-info",
    warning: "bg-warning",
  }

  const colorClass = colorMap[type]

  if (!show) return null

  return (
    <div className="position-fixed bottom-0 end-0 p-3" style={{ zIndex: 9999 }}>
      <div
        className="toast show rounded"
        role="alert"
        aria-live="assertive"
        aria-atomic="true"
        style={{ backgroundColor: "#fff", borderRadius: "0.5rem" }}
      >
        <div className="toast-header rounded-top">
          <div
            className={`${colorClass} rounded me-2 d-inline-block`}
            style={{ width: "20px", height: "20px" }}
          ></div>
          <strong className="me-auto">{title}</strong>
          <small>Just now</small>
          <button type="button" className="btn-close" onClick={onClose} aria-label="Close"></button>
        </div>
        <div className="toast-body">{message}</div>
      </div>
    </div>
  )
}

export default ToastNotification
